export default "__VITE_ASSET__CLlOPuKn__"